import { t } from "@lingui/macro";
import { useState } from "react";

import { isLikelyEgyptBuyer } from "@/client/libs/payment-region";

/**
 * One muted line near a paid CTA, shown only to browsers in Egypt's timezone.
 * Egyptian EGP debit cards often block USD / international online charges;
 * Lemon Squeezy cancels those without telling the buyer why. PayPal is a tab
 * on our checkout page, so we point at it without promising anything else.
 */
export const EgyptCardHint = ({ className }: { className?: string }) => {
  // Read once per mount: the timezone does not change during a visit.
  const [show] = useState(isLikelyEgyptBuyer);
  if (!show) return null;
  return (
    <p className={className ?? "text-xs text-muted-foreground"} data-testid="egypt-card-hint">
      {t`Paying from Egypt? Use a card enabled for international (USD) payments, or PayPal.`}
    </p>
  );
};
